import styled from 'styled-components';

export const StyledListPost = styled.div`
  padding: 20px;
  max-height: calc(100vh - 210px);
  overflow: auto;

  .list {
    min-height: 300px;
  }
  .list-item {
    cursor: pointer;
  }
  .loading {
    margin: 20px 0;
    margin-bottom: 20px;
    padding: 30px 50px;
    text-align: center;
    width: 100%;
  }
`;
